import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchContent } from "../redux/actions/contentActions";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();

  // Access content state from Redux
  const { loading, data, error } = useSelector((state) => state.content);

  useEffect(() => {
    dispatch(fetchContent("privacy_policy"));
  }, [dispatch]);

  return (
    <div className="container">
      <div>
        <p className="text-medium-theme-color mt-4 text-xl lg:text-3xl font-semibold">
          Privacy Policy
        </p>
      </div>

      <div className="my-4 flex flex-col gap-2 text-base lg:text-lg">
        {loading && <p>Loading content...</p>}

        {error && (
          <p className="text-red-600 font-semibold">
            "Failed to load Privacy Policy content."
          </p>
        )}

        {/* {!loading && !error && data?.description && (
          <p>{data.description}</p>
        )} */}

        {!loading && !error && data?.description && (
          <div dangerouslySetInnerHTML={{ __html: data.description }}>
            {/* {data.description
              .split(/\n+/) // Split by line breaks
              .map((line, index) => {
                const trimmed = line.trim();

                if (!trimmed) return null;

                // Check if line is all uppercase (and possibly includes numbers or punctuation)
                const isAllCaps = /^[A-Z\s\d\-\:\.]+$/.test(trimmed) && /[A-Z]/.test(trimmed);

                if (isAllCaps) {
                  return (
                    <p
                      key={index}
                      style={{
                        fontWeight: 'bold',
                        marginTop: '20px',
                        marginBottom: '10px',
                      }}
                    >
                      {trimmed}
                    </p>
                  );
                } else if (/^(•|\d+\.)/.test(trimmed)) {
                  // List item
                  return (
                    <ul key={index} style={{ paddingLeft: 16, margin: 0 }}>
                      <li>{trimmed}</li>
                    </ul>
                  );
                } else {
                  // Regular paragraph
                  return <p key={index}>{trimmed}</p>;
                }
              })} */}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
